<!-- 宠物照 -->
<template>
  <section class="theme-display" @scroll="handleScroll" ref="container">
    <img class="banner_inner" :src="bannerInnerImg" alt="">
    <img class="banner" :src="bannerImg" @load="bannerLoad">
    <div class="nav-btn-con" ref="navBtnCon">
      <div class="nav" :class="{'nav-fixed': fixNavTop}">
        <div class="main-nav">
          <div class="nav-btn-group" v-for="(ids, index) in topNavs" :key="index">
            <a class="nav-btn" :class="{'nav-btn-active': NAVS_IMG_MAP[id].includes(activeId)}" v-for="id in ids"
              :key="id" :data-id="id" @click="handleNavClick">
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 图片展示 -->
      <div class="img-list-wrap" @click="handleClick">
        <div class="img-con" ref="imgCon" v-for="img in pictures" :key="img.id">
          <img :ref="img.id" :src="img.src" :data-id="img.id" />
        </div>
        <!-- <img class="img-con" :src="authorityImg" /> -->
      </div>
    </div>
  </section>
</template>
<script>
import minirouterMethod from '@/mixins/minirouterMethod.js'
const PROD_CATE_PET = '25624'
const PET_1_1 = '01'
const PET_1_2 = '02'
const PET_2_1 = '03'
const PEOPLE_PET_1_1 = '04'
const PEOPLE_PET_1_2 = '05'
const PEOPLE_PET_2_1 = '06'
const PEOPLE_PET_2_2 = '07'
const TOP_NAVS = [
  [PET_1_1, PET_2_1],
  [PEOPLE_PET_1_1, PEOPLE_PET_2_1]
]
const NAVS_IMG_MAP = {
  [PET_1_1]: [PET_1_1, PET_1_2],
  [PET_2_1]: [PET_2_1],
  [PEOPLE_PET_1_1]: [PEOPLE_PET_1_1, PEOPLE_PET_1_2],
  [PEOPLE_PET_2_1]: [PEOPLE_PET_2_1, PEOPLE_PET_2_2]
}

export default {
  name: 'themePregnancy',
  mixins: [minirouterMethod],
  data() {
    return {
      NAVS_IMG_MAP,
      activeId: PET_1_1,
      bannerImg: require('./assets/banner.jpg'),
      bannerInnerImg: require('./assets/banner_inner.gif'),
      // authorityImg: require('./assets/authority.jpg'),
      navToTop: 0,
      navOffSetHeight: 0,
      topNavs: TOP_NAVS,
      pictures: [
        {
          id: PET_1_1,
          src: require('./assets/1_1.jpg')
        },
        {
          id: PET_1_2,
          src: require('./assets/1_2.jpg')
        },
        {
          id: PET_2_1,
          src: require('./assets/2_1.jpg')
        },
        {
          id: PEOPLE_PET_1_1,
          src: require('./assets/3_1.jpg')
        },
        {
          id: PEOPLE_PET_1_2,
          src: require('./assets/3_2.jpg')
        },
        {
          id: PEOPLE_PET_2_1,
          src: require('./assets/4_1.jpg')
        },
        {
          id: PEOPLE_PET_2_2,
          src: require('./assets/4_2.jpg')
        }
      ],
      fixNavTop: false
    }
  },
  methods: {
    async bannerLoad() {
      await this.$nextTick()
      this.navToTop = this.$refs.navBtnCon?.offsetTop || 0;
    },
    // 点击切换nav
    handleNavClick(e) {
      let prodId = e.target.dataset.id
      if (!prodId) return
      this.activeId = String(prodId)
      let diff = null;
      switch (prodId) {
      case PET_1_1:
        diff = 200
        break
      case PET_2_1:
        diff = 35
        break
      default:
        diff = 10;
      }
      this.$refs['container'].scrollTop = this.$refs[this.activeId][0].offsetTop - this.navOffSetHeight + diff
    },
    // 监听点击事件并跳转到对应产品
    handleClick(e) {
      this.miniRouterLink('blue', PROD_CATE_PET)
    },
    // 监听页面滚动
    handleScroll(e) {
      let scrolledDistance = e.target.scrollTop + this.navOffSetHeight;
      this.fixNavTop = e.target.scrollTop > this.navToTop - 10
      let imgCon = this.$refs.imgCon || [];
      if (imgCon.length === 0) {
        return;
      }
      let pictures = this.pictures
      if (scrolledDistance < imgCon[0].offsetTop - 400) {
        this.activeId = pictures[0].id
        return
      }
      for (let i = 0; i < imgCon.length - 1; i++) {
        if (scrolledDistance > imgCon[i].offsetTop - 200 && scrolledDistance < imgCon[i + 1].offsetTop - 200) {
          this.activeId = pictures[i].id
        }
      }
      if (scrolledDistance > imgCon[imgCon.length - 1].offsetTop - 200) {
        this.activeId = pictures[imgCon.length - 1].id
      }
    }
  },
  mounted() {
    this.activeId = this.pictures[0].id,
    this.navOffSetHeight = this.$refs.navBtnCon.offsetHeight;
  }
}
</script>
<style lang="less" scoped>
  @import './index.less';
</style>
